// extracted by mini-css-extract-plugin
export default {"buttonOnTop":"M6kEey","buttonInDescription":"M_G02M","content":"ac8C9F","title":"mVZMo4","count":"ujk9bQ","description":"ZFfHIE"};